const VENUE_PATH = /^\/wineries\/([a-f0-9]{24})\/?$/i;
/**
 * The URL printed in a venue's check-in QR code. Scanned by a plain phone
 * camera it opens the venue page; the app reads the `ci` token from it.
 *
 * @example buildCheckInQrUrl('https://wineryxplorer.com', id, 'tok') // 'https://wineryxplorer.com/wineries/<id>?ci=tok'
 */
export const buildCheckInQrUrl = (webOrigin, venueId, token) => `${webOrigin.replace(/\/+$/, '')}/wineries/${venueId}?ci=${encodeURIComponent(token)}`;
/**
 * Reads the venue id and token from scanned QR text, or null when the text is
 * not a check-in code. Host and scheme are ignored so codes printed from any
 * environment parse the same way.
 */
export const parseCheckInQr = (payload) => {
    let url;
    try {
        url = new URL(payload);
    }
    catch {
        return null;
    }
    const match = VENUE_PATH.exec(url.pathname);
    const token = url.searchParams.get('ci');
    if (!match || !token)
        return null;
    return { venueId: match[1], token };
};
